export enum BoxType {
    In = 0,
    Out = 1,
    Local = 2
}